import axios from 'axios';

// Create an axios instance with the base URL pointing to the backend API
// Adjust the base URL as needed for different environments.
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "/api",
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  const employeeId = localStorage.getItem("active_employee_id");
  if (employeeId) {
    config.headers["X-Employee-Id"] = employeeId;
  }
  return config;
}, error => Promise.reject(error));

api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      console.warn("[Auth] 401 Unauthorized - Session may be expired.");
    }
    return Promise.reject(error);
  }
);

export default api;

